import { createI18n } from 'vue-i18n'
import enLocale from '@/i18n/en.json'
import nlLocale from '@/i18n/nl.json'

export default createI18n({
	legacy: false,
	locale: 'nl',
	fallbackLocale: 'en',
	messages: {
		en: enLocale,
		nl: nlLocale
	}
})
